import React from 'react';
import { SearchIcon, MapIcon, RocketIcon } from 'lucide-react';
const steps = [{
  number: '01',
  title: 'Understand Your Position',
  description: 'We look at where you are now — your equity, structure, income, and goals. No assumptions.',
  icon: SearchIcon
}, {
  number: '02',
  title: 'Build Your Strategy',
  description: "Together we map out the right approach for your next move — whether that's your first home or your fifth investment.",
  icon: MapIcon
}, {
  number: '03',
  title: 'Execute & Move Forward',
  description: "We handle the lending, structure it properly, and set you up so you're ready for the move after that.",
  icon: RocketIcon
}];
export function HowItWorksSection() {
  return <section className="py-24 bg-white dark:bg-[#0f1629]/80 border-t border-slate-100 dark:border-white/5 transition-colors duration-300 relative z-10" data-id="element-117">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-118">
        <div className="text-center mb-16" data-id="element-119">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-50 dark:bg-white/5 border border-slate-200 dark:border-white/10 shadow-sm dark:shadow-none mb-6" data-id="element-120">
            <span className="text-sm font-medium text-primary-600 dark:text-primary-400" data-id="element-121">
              Simple Process
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4" data-id="element-122">
            How It Works
          </h2>
          <p className="text-lg text-slate-500 dark:text-slate-400 max-w-2xl mx-auto" data-id="element-123">
            A clear process that works for everyone — whether you're buying your
            first home or your next investment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto relative" data-id="element-124">
          {/* Connecting line (desktop) */}
          <div className="hidden md:block absolute top-16 left-[20%] right-[20%] h-px bg-gradient-to-r from-transparent via-slate-300 dark:via-white/10 to-transparent" data-id="element-125"></div>

          {steps.map((step, index) => {
          const Icon = step.icon;
          return <div key={index} className="relative flex flex-col items-center text-center" data-id="element-126">
                {/* Step circle */}
                <div className="relative mb-8" data-id="element-127">
                  <div className="w-20 h-20 rounded-2xl bg-slate-50 dark:bg-[#1a2035] border-2 border-slate-200 dark:border-white/10 flex items-center justify-center shadow-sm dark:shadow-none relative z-10" data-id="element-128">
                    <Icon className="w-8 h-8 text-primary-600 dark:text-primary-400" data-id="element-129" />
                  </div>
                  <div className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-gradient-to-br from-accent-500 to-primary-500 text-white text-xs font-bold flex items-center justify-center shadow-md z-20" data-id="element-130">
                    {step.number}
                  </div>
                </div>

                <h3 className="text-lg font-bold text-slate-900 dark:text-white mb-3" data-id="element-131">
                  {step.title}
                </h3>
                <p className="text-sm text-slate-500 dark:text-slate-400 leading-relaxed max-w-xs" data-id="element-132">
                  {step.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}